import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans } from 'react-i18next';
import { Button, Popup } from 'next-common-lib';
import i18n from 'i18n';
import { PORTAL_MAIN_URL } from 'constants/wizardConstants';
import * as wizardActions from 'redux/ducks/common/wizardDuck';

export const WizardClosePopup = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(state => state.wizard.isQuit);

  const handleOnClose = () => {
    dispatch(wizardActions.closeQuit());
  };

  return (
    <>
      {isOpen && (
        <Popup
          id="wizard_close"
          isShow={isOpen}
          isDimed={isOpen}
          dimedClassName="transparent"
          size="sm"
          className="w-popup"
          zIndex={3000}
          isDimedOverlap
          componentType="normalPopup"
          headerComponent={[
            <h1 className="popup-title" key={1}>
              {i18n.t('BTY_W_T_QUIT')}
            </h1>,
          ]}
          contentsComponent={[
            <>
              <div className="grid-box-wrap">
                <div className="grid-box">
                  <span className="img empty-workspace" />
                </div>
              </div>
              <Trans i18nKey="BTY_W_T_QUIT_T" />
            </>,
          ]}
          bottomComponent={[
            <div className="btn-set al-right">
              <div className="btn-group">
                <Button
                  componentType="solid"
                  className="secondary"
                  size="md"
                  label={i18n.t('BTY_M_QUIT_END')}
                  onClick={() => {
                    dispatch(wizardActions.closeQuit());
                    dispatch(wizardActions.endSetup());
                    window.location.href = PORTAL_MAIN_URL;
                  }}
                />
                <Button
                  componentType="solid"
                  className="primary"
                  size="md"
                  label={i18n.t('BTY_M_QUID_RETURN')}
                  onClick={() => {
                    handleOnClose();
                  }}
                />
              </div>
            </div>,
          ]}
          closeFunction={() => {
            handleOnClose();
          }}
        />
      )}
    </>
  );
};
WizardClosePopup.propTypes = {};
WizardClosePopup.defaultProps = {};
export default WizardClosePopup;
